import(/* webpackMode: "eager" */ "/app/src/app/(main-app)/faq/page.tsx");
